import { createGlobalStyle, keyframes } from 'styled-components';
import { ThemeDefinitions } from './ThemeComponents';
import { defaultTheme} from '../config';

const pulse = keyframes`
0% {
  transform: scale(0.7);
  opacity: 1;
  background: rgb(250,0,0);
  border: 0;
}
30%{
  transform: scale(1.3);
  opacity: 0.5;
  background: rgb(150,0,0);
  border: 2px solid rgb(250,0,0);
}
100%{
  transform: scale(1.1);
  opacity: 0.75;
  background: #fff;
  border: 1px solid rgb(250,0,0);
}
`;
const waveTop = keyframes`
from {

  top: -210px;
  transform: rotateX(0deg);
}
to{

  top: -180px;
  transform: rotateX(30deg);
}
`;

const waveBottom = keyframes`
from {

  bottom: -210px;
  transform: rotateX(0deg);
}
to{

  bottom: -180px;
  transform: rotateX(30deg);

}
`;

const shadowKey = keyframes`
0% {
  transform:translateY(0);
-webkit-filter: drop-shadow(0px 12px 25px rgba(0,0,0,0.5));

-ms-filter: "progid:DXImageTransform.Microsoft.Dropshadow(OffX=0, OffY=12, Color='#444')";
filter: "progid:DXImageTransform.Microsoft.Dropshadow(OffX=0, OffY=12, Color='#444')";
filter: drop-shadow(0px 12px 25px rgba(0,0,0,0.5));
}
50%{
  transform:translateY(-10px);
  -webkit-filter: drop-shadow(0px 12px 25px rgb(0,102,178));

-ms-filter: "progid:DXImageTransform.Microsoft.Dropshadow(OffX=0, OffY=12, Color='rgb(0,102,178)')";
filter: "progid:DXImageTransform.Microsoft.Dropshadow(OffX=0, OffY=12, Color='rgb(0,102,178)')";
filter: drop-shadow(0px 12px 25px rgb(0,102,178));

}
100% {
  transform:translateY(0);
-webkit-filter: drop-shadow(0px 12px 25px rgba(0,0,0,0.5));

-ms-filter: "progid:DXImageTransform.Microsoft.Dropshadow(OffX=0, OffY=12, Color='#444')";
filter: "progid:DXImageTransform.Microsoft.Dropshadow(OffX=0, OffY=12, Color='#444')";
filter: drop-shadow(0px 12px 25px rgba(0,0,0,0.5));
}
`;

export default createGlobalStyle`

@font-face {
    font-family: AkzidenzGrotesk-Regular;
    src: url("/assets/fonts/AkzidenzGrotesk-Regular.otf") format("opentype");
}


@font-face {
    font-family: AkzidenzGrotesk-ExtraBoldCondAlt;
    src: url("/assets/fonts/AkzidenzGrotesk-ExtraBoldCondAlt.otf") format("opentype");
}

@font-face {
    font-family: AkzidenzGrotesk-BoldExtended;
    src: url("/assets/fonts/AkzidenzGrotesk-BoldExtended.otf") format("opentype");
}


*{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  outline: 0
}

html{
  width: 100%;
  min-height: 100vh !important;

  background: #36A99A;
  


  background-attachment: fixed;
  background-size: cover;

}

body {
  background: rgb(220,220,220);
  //background: url('/assets/evento/fundo.png') no-repeat center top;
  background-size: cover;
  background-attachment: fixed;
  color: #fff;
  -webkit-font-smoothing: antialiased;
  padding: 0;
  margin: 0 !important;
  min-height: 100vh !important;
  min-height: 100% !important;
  position: relative;



}

#root{
  min-min-height: 100vh;
  padding-bottom: 50px;

}

body, input, button{
  font-family: 'AkzidenzGrotesk-Regular', Helvetica,  sans-serif;
  font-size: 16px;


}

h1,h2,h3,h4,h5,h6, strong{
font-weight: bold;
font-family:  'AkzidenzGrotesk-BoldExtended',Helvetica,  sans-serif;

}

h2{

      font-size: 16px;
}

p, span{
  font-family:'AkzidenzGrotesk-Regular',Helvetica,  sans-serif;
}

p, span, li, nav{
  font-family:'AkzidenzGrotesk-Regular',Helvetica,  sans-serif;
  line-height: 1.3rem;
  list-style:none;
}


button{
  cursor: pointer;
}

.wave {

  width: 200%;
  margin-left: -20%;
  z-index:0;

  @media (max-width: 1250px) {
    width: 400%;
    margin-left: -50%;
  }

  @media (max-width: 750px) {
    width: 800%;
    margin-left: -50%;
  }



}

.fixedTop {
 position: fixed;
 top: -210px;
 animation: ${waveTop} 5s infinite alternate-reverse ease;
 left: 0;
}

.fixedBottom{
  position: fixed;
 bottom: -210px;
 animation: ${waveBottom} 5s infinite alternate-reverse;
 left: 0;

}

.computerOnly{
display: flex;
@media (max-width: 1200px) {
    display: none;
  }
}

.mobileOnly{
display: none;
@media (max-width: 1200px) {
    display: flex;
  }
}

button.defaultButton {
         margin-top: 10px;
      width: 200px;
      min-width: 200px;
      padding: 20px;
      text-align: center;
      background: #36A99A !important;
      color: #fff  !important;

      transition: background 0.5s;
      border: 0;
      border-radius: 32px;

      &:hover {
        background: #36A99A  !important;
      }
    }

    button.defaultButtonReverse {
         margin-top: 10px;
      width: 200px;
      min-width: 200px;
      padding: 20px;
      text-align: center;
      background:  #fff  !important;
      color: #36A99A !important;

      transition: background 0.5s;
      border: 0;
      border-radius: 32px;

      &:hover {
        background: #36A99A  !important;
      }
    }


    button.defaultButtonMini {
         margin-top: 10px;
      width: 50px !important;
      display: flex;
      justify-content: center;
      align-items: center;
      min-width: 20px;
      height: 30px;
      text-align: center;
      background: #0D3E64 !important;
      color: #fff  !important;

      transition: background 0.5s;
      border: 0;
      border-radius: 8px;

      &:hover {
        background: #0D3E64  !important;
      }
    }

    a {
      text-decoration: none !important;
    }

    .shadowed {
    -webkit-filter: drop-shadow(12px 12px 25px rgba(0,0,0,0.5));

    -ms-filter: "progid:DXImageTransform.Microsoft.Dropshadow(OffX=12, OffY=12, Color='#444')";
    filter: "progid:DXImageTransform.Microsoft.Dropshadow(OffX=12, OffY=12, Color='#444')";
    filter: drop-shadow(12px 12px 25px rgba(0,0,0,0.5));

    animation : ${shadowKey} 5s infinite;
}

.colorWhite{
  color : #fff !important;
}


input, select{





/*Change text in autofill textbox*/
&:-webkit-autofill,
&:-webkit-autofill:hover,
&:-webkit-autofill:focus,
&:-webkit-autofill:active {
    -webkit-transition: "color 9999s ease-out, background-color 9999s ease-out";
    -webkit-transition-delay: 9999s;
}
}

.separator {
    width: 100%;
    max-width: 100%;
    height: 2px;
    background: rgb(0, 102, 178);
    margin: 20px auto;
  }

.buttonDiv {
  width: 100%;

  display: flex;
  justify-content: stretch;
  align-itens: center;
  
  >div{
    display: flex;
    justify-content: center;
    align-itens: center;
    width: 100%;
 

  >.squareButton, .squareButtonReverse  {
    background: coral;
    color: #fff;
    padding: 10px;
    border-radius: 0;
    border: 0;
    transition: 0.4s all;
    position: relative;
    display: flex;
    align-itens: center;
    margin: 5px 7.5px;

    &:hover {
      opacity: 0.8;
    }
  }
  >.squareButtonReverse {
    background: #fff;
    color: coral;
  }
}  }

.redBall {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: red;
  margin: 5px;
  animation : ${pulse} 1s infinite;
}

.defaultBackground {
  background: ${defaultTheme.defaultBackground};
  color:  ${defaultTheme.defaultColor};
  padding: 10px;
  
}

.flexRow {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-wrap: wrap;
  flex-direction: row;
}

.flexColumn {
  display: flex;
  align-items: center;
  justify-content: flex-start;
flex-direction: column;
  
}

`;
